import React from "react";

import StahsedLogo from "assets/stashed-logo.svg";

const Logo = () => {
  return <img src={StahsedLogo} className='spacing' />;
};

export default Logo;
